import React from 'react';
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormGroup from '@material-ui/core/FormGroup';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import PublicLayout from '../../../layouts/public';
import { lzGetAssetUrl, lzShowSuccessMessage } from '../../../../services/LzUtils';
import ImgLogo from '../../../../assets/images/logo.png';
import ImgLzLogo from '../../../../assets/images/lz-logo.png';
import { Link } from 'react-router-dom';
import { lzCallApi, lzParseLoggedInData } from '../../../../services/LzApiService';

class LoginScreen extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      model: {
        username: '',
        wp: '',
        remember: true,
      },
    };
  }

  handleInputChange = (name, value) => {
    this.setState({ [name]: value });
  };

  onSubmit(evt) {
    evt.preventDefault();
    this.callLoginApi();
  }

  async callLoginApi() {
    const { history } = this.props;
    const { model } = this.state;

    // Make the api call and get processed data
    const data = await lzCallApi('login', model, 'post');

    // console.log('LOGIN DATA:', data);

    // Validate data and save
    if (lzParseLoggedInData(data, model.remember)) {
      console.log('REDIRECTING...');

      history.replace('/');

      lzShowSuccessMessage('logged in successfully! loading dashboard...');
      // used replace instead of push to remove login from browser history
      // and make it go to exit if back pressed
    }
  }

  render() {
    const { model } = this.state;

    return (
      <PublicLayout>
        <div className="full-page-form">
          <Card className="card">
            <div className="half-form bg-signin">
              <form noValidate autoComplete="off" onSubmit={(evt) => this.onSubmit(evt)}>
                <img src={lzGetAssetUrl(ImgLogo)} alt="Logo" className="logo" />

                <h2>Dealer Sign-In</h2>

                <FormGroup row>
                  <TextField fullWidth variant="outlined" label="Email" value={model.username}
                    onChange={(ev) => this.setState({ model: Object.assign({}, model, { username: ev.target.value }) })}
                  />
                </FormGroup>

                <FormGroup row>
                  <TextField fullWidth variant="outlined" label="Password" type="password" value={model.wp}
                    onChange={(ev) => this.setState({ model: Object.assign({}, model, { wp: ev.target.value }) })}
                  />
                </FormGroup>

                <FormGroup row>
                  <Grid container>
                    <Grid item xs={6}>
                      <FormControlLabel
                        control={
                          <Checkbox checked={model.remember}
                            onChange={(ev) => this.setState({ model: Object.assign({}, model, { remember: ev.target.checked }) })}
                          />
                        }
                        label="Remember me!"
                      />
                    </Grid>
                    <Grid item xs={6} style={{ textAlign: 'right', marginTop: 12 }}>
                      <Link to={'/user/forgot-password/' + model.username}>Forgot your password?</Link>
                    </Grid>
                  </Grid>
                </FormGroup>

                <FormGroup row>
                  <Grid container>
                    <Grid item xs={6}>
                      <Button type="submit" variant="contained" color="primary">Sign-In</Button>
                    </Grid>
                    <Grid item xs={6} style={{ textAlign: 'right', marginTop: 12 }}>
                      {<Link to={'/user/register'}>Sign-Up for an account</Link>}
                    </Grid>
                  </Grid>
                </FormGroup>
              </form>
            </div>
          </Card>
          <a href="https://logic-zone.net/?ref=services.2adata" target="_blank" rel="noreferrer" className="powered-by">
            Powered by :
            <img src={lzGetAssetUrl(ImgLzLogo)} alt="Logic-Zone" />
          </a>
        </div>
      </PublicLayout>
    );
  }

}

export default LoginScreen;
